var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.hasMultipleFederations)?[_c('v-select',{staticClass:"w-100",attrs:{"options":_vm.federations,"label":"text","reduce":(v)=>v.value,"disabled":_vm.disabled},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]:[_vm._v(" "+_vm._s(_vm.selectSingleFederation)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }